import { render } from "./BaseFormSelect.vue?vue&type=template&id=345b0812&ts=true"
import script from "./BaseFormSelect.vue?vue&type=script&lang=ts"
export * from "./BaseFormSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__